export type SubscriptionType = "basic";
export type CurrencyString = "USD";
export type Period = "yearly" | "quarterly" | "semestral";

// Plan id sent to the backend (resolveStripePlanId). Note this is the backend's
// contract vocabulary: "annual" here maps to the web `Period` "yearly".
export type StripePlanId = "annual" | "semestral" | "quarterly";

export enum ExperimentOfferFlow  {
  control = "control",
  multiplan = "multiplan"
}

export type Trial = {
  days: number;
  paymentAfterTrial: {
    amount: number;
    currency: CurrencyString;
    period: Period;
  };
  stripeSetupIntent: {
    clientSecret: string;
  };
};

export type Payment = {
  amount: number;
  currency: CurrencyString;
  period: Period;
  stripePaymentIntent: {
    clientSecret: string;
  };
};

export type SubscriptionStatus = {
  subscription: {
    [key in SubscriptionType]: {
      hasSubscription: boolean;
      hasTrial: boolean;
      experimentOfferFlow: ExperimentOfferFlow;
    };
  };
};

export type PaymentInfo = {
  trial?: Trial;
  payment?: Payment;
};


export type PaymentData = {
  amount: number;
  period: Period;
  currency: CurrencyString;
};

export type PeriodTimeForms = {
  adjective: string;
  adverb: string;
};

export type PeriodMapping = {
  [key in Period]: PeriodTimeForms;
};

export enum ButtonVariant {
  primary = "primary",
  secondary = "secondary",
  transparent = "transparent",
}
